// src/components/NavigationButtons.jsx
import React from 'react';

const NavigationButtons = ({ 
  previousEventData, 
  nextEventData, 
  previousEventDataCategory,
  nextEventDataCategory,
  navigate, 
  currentEvent 
}) => {
  if (!previousEventData && !nextEventData && !previousEventDataCategory && !nextEventDataCategory) return null;

  console.log('Current Event:', currentEvent);
  console.log('Previous:', previousEventData);
  console.log('Next:', nextEventData);

  // Determina se lo show corrente è un PLE o settimanale
  const isCurrentPLE = currentEvent?.type === 'ple';
  const currentShowName = currentEvent?.nome || '';

  console.log('Is PLE:', isCurrentPLE);
  console.log('Current Show Name:', currentShowName);

  // Funzione per verificare se due show hanno lo stesso nome
  const hasSameName = (eventName1, eventName2) => {
    if (!eventName1 || !eventName2) return false;
    return eventName1 === eventName2;
  };

  // Funzione per determinare se due show sono nella stessa categoria
  const isSameCategory = (eventData) => {
    if (!eventData) return false;
    
    if (isCurrentPLE) {
      return eventData.type === 'ple';
    } else {
      return eventData.type === 'weekly';
    }
  };

  // Stili corretti senza mix di proprietà
  const getButtonStyle = (eventData, isPrevious = false) => {
    const gradient = isPrevious 
      ? 'linear-gradient(90deg, rgba(0,0,0,0.7) 30%, rgba(0,0,0,0.4) 100%)'
      : 'linear-gradient(270deg, rgba(0,0,0,0.7) 30%, rgba(0,0,0,0.4) 100%)';
    
    return {
      backgroundImage: `${gradient}, url(${eventData.sfondo || ''})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '85px',
      color: 'white',
      flexBasis: '45%'
    };
  };

  // Funzione per formattare la data
  const formatDate = (dateData) => {
    if (!dateData) return '';
    
    try {
      if (dateData.seconds) {
        return new Date(dateData.seconds * 1000).toLocaleDateString('it-IT', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
      }
      if (dateData.toDate) {
        return dateData.toDate().toLocaleDateString('it-IT', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
      }
      if (dateData instanceof Date) {
        return dateData.toLocaleDateString('it-IT', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
      }
      return '';
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  };

  return (
    <div className="mt-2">
      {/* PRIMA RIGA: Navigazione cronologica */}
      <div className="d-flex flex-nowrap justify-content-center gap-2 w-100 mb-3">
        {previousEventData && (
          <button
            className={`btn flex-grow-1 border-0 shadow-lg text-start p-0 rounded-2 overflow-hidden ${
              !isSameCategory(previousEventData) ? 'opacity-75' : ''
            }`}
            style={getButtonStyle(previousEventData, true)}
            onClick={() => navigate(`/shows/${previousEventData.id}`)}
          >
            <div className="d-flex align-items-center h-100 px-3">
              <i className="bi bi-chevron-left fs-1 me-2"></i>
              <div className="text-truncate">
                <div className="fw-bold fs-6 fs-sm-5 text-truncate">
                  {previousEventData.nome || 'Show precedente'}
                </div>
                <div className="small text-light opacity-75">
                  {formatDate(previousEventData.data)}
                </div>

              </div>
            </div>
          </button>
        )}

        {nextEventData && (
          <button
            className={`btn flex-grow-1 border-0 shadow-lg text-end p-0 rounded-2 overflow-hidden ${
              !isSameCategory(nextEventData) ? 'opacity-75' : ''
            }`}
            style={getButtonStyle(nextEventData, false)}
            onClick={() => navigate(`/shows/${nextEventData.id}`)}
          >
            <div className="d-flex align-items-center justify-content-end h-100 px-3">
              <div className="text-truncate">
                <div className="fw-bold fs-6 fs-sm-5 text-truncate">
                  {nextEventData.nome || 'Show successivo'}
                </div>
                <div className="small text-light opacity-75">
                  {formatDate(nextEventData.data)}
                </div>
              </div>
              <i className="bi bi-chevron-right fs-1 ms-2"></i>
            </div>
          </button>
        )}
      </div>

      {/* SECONDA RIGA: Navigazione per categoria */}
      <div className="d-flex flex-nowrap justify-content-center gap-2 w-100 mb-2">
        {previousEventDataCategory && (
          <button
            className="btn flex-grow-1 border-0 shadow-lg text-start p-0 rounded-2 overflow-hidden"
            style={getButtonStyle(previousEventDataCategory, true)}
            onClick={() => navigate(`/shows/${previousEventDataCategory.id}`)}
          >
            <div className="d-flex align-items-center h-100 px-3">
              <i className="bi bi-chevron-left fs-1 me-2"></i>
              <div className="text-truncate">
                <div className="fw-bold fs-6 fs-sm-5 text-truncate">
                  {previousEventDataCategory.nome || 'Show precedente'}
                </div>
                <div className="small text-light opacity-75">
                  {formatDate(previousEventDataCategory.data)}
                </div>
                {/* Badge categoria */}
                <div className="d-flex gap-1 mt-1">
                </div>
              </div>
            </div>
          </button>
        )}

        {nextEventDataCategory && (
          <button
            className="btn flex-grow-1 border-0 shadow-lg text-end p-0 rounded-2 overflow-hidden"
            style={getButtonStyle(nextEventDataCategory, false)}
            onClick={() => navigate(`/shows/${nextEventDataCategory.id}`)}
          >
            <div className="d-flex align-items-center justify-content-end h-100 px-3">
              <div className="text-truncate">
                <div className="fw-bold fs-6 fs-sm-5 text-truncate">
                  {nextEventDataCategory.nome || 'Show successivo'}
                </div>
                <div className="small text-light opacity-75">
                  {formatDate(nextEventDataCategory.data)}
                </div>
                {/* Badge categoria */}
                <div className="d-flex gap-1 mt-1 justify-content-end">
                </div>
              </div>
              <i className="bi bi-chevron-right fs-1 ms-2"></i>
            </div>
          </button>
        )}
      </div>

      {/* Suggerimento per l'utente */}
      {(!previousEventData && !nextEventData && !previousEventDataCategory && !nextEventDataCategory) && (
        <div className="text-center text-muted small py-2">
          Nessuno show disponibile per la navigazione
        </div>
      )}
    </div>
  );
};

export default NavigationButtons;